import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Subject, throwError, Observable, ReplaySubject, catchError as catchError$1 } from 'rxjs';
import { tap, catchError, map, publishReplay, refCount, share, takeUntil } from 'rxjs/operators';
import * as i2 from '@mare-common/ngx-mare-common';
import { NgxMareCommonModule } from '@mare-common/ngx-mare-common';
import * as i3 from '@angular/platform-browser';

class TokenServiceAbstract {
    constructor() {
        if (this.isSilentRefreshTokenEnabled()) {
            this.startSilentRefreshToken();
        }
    }
    startSilentRefreshToken() {
        console.debug('startSilentRefreshToken');
        let exp = this.getTokenExpirationDate();
        if (!exp) {
            return;
        }
        let now = Math.ceil(new Date().getTime() / 1000);
        const diff = exp - now; // > 0 if token is not expired yet 
        let toRefresh = false;
        if (diff < 0) { // token expired
            console.debug('startSilentRefreshToken token expired');
            let refreshExp = this.getRefreshTokenExpirationDate();
            if (refreshExp && now < refreshExp) { // refresh token not expired
                toRefresh = true;
            }
        }
        else { // token not expired
            console.debug('startSilentRefreshToken token not expired...');
            setTimeout(() => {
                this.startSilentRefreshToken();
            }, 60000);
        }
        if (!toRefresh) {
            return;
        }
        console.debug('startSilentRefreshToken toRefresh');
        this.triggerRefreshAndRetrieve().then((t) => {
            console.info('Token refreshed');
            this.startSilentRefreshToken();
        }).catch((err) => {
            console.info('Token not refreshed');
        });
    }
}

class ApiServiceOptions {
    constructor() {
        this.checkLoggedIn = false;
    }
}
class ApiService {
    constructor(http, 
    // private localAccountService: LocalAccountService,
    sanitizer, authService, errorHandler, eventInteractionService
    // private next: HttpHandler,
    // public authService: AuthService
    ) {
        this.http = http;
        this.sanitizer = sanitizer;
        this.authService = authService;
        this.errorHandler = errorHandler;
        this.eventInteractionService = eventInteractionService;
        this.configured = false;
        this.destroy$ = new Subject();
        // URL: string = 'http://tutoraggio.eclettica.net';
        // URL: string = 'http://192.168.0.183:8200';
        // Used from CORS backend issue
        // host = 'http://localhost:8200/';
        // LOCAL
        // URL = '/api';
        // REMOTE
        this._URL = '/selfcaring/bo';
        this.SSOURL = '/selfcaring';
        this.blobData = {};
        // if (environment.production || environment.local) {
        //   this.URL() = '/tutoraggio/bo';
        // }
        // else {
        //   this.URL() = '/localtutoraggio/bo';
        // }
    }
    setEnvironment(serviceEndpoint, wpnonce, basicauth) {
        if (this.configured)
            return;
        this._URL = serviceEndpoint;
        this.basicAuth = basicauth;
        this.wpnonce = wpnonce;
        this.configured = true;
    }
    // setFileHeaders(): Promise<HttpHeaders> {
    //   return new Promise((resolve) => {
    //     // const token: string = this.wpnonce;
    //     // const headers: HttpHeaders = new HttpHeaders()
    //     //   .set('Content-Type', 'application/json')
    //     //   // .set('Authorization', 'Basic YmFuY29tYXR1c2VyOk1hbmRhcmluby4k')
    //     //   .set('X-WP-Nonce', `${token}`)
    //     //   .set('Authorization', `Basic ${this.basicAuth}`);
    //     const token: string | undefined = this.authService.getAccessToken();
    //     const headers: HttpHeaders = new HttpHeaders()
    //     // .set('Content-Type', 'application/json')
    //     // .set('Authorization',  `Basic ${this.basicAuth}`)
    //     .set('authtoken', `${token}`);
    //     resolve(headers);
    //   });
    // }
    // setFileHeaders() {
    //   const token: string | undefined = this.userService.getToken();
    //   // const token: string = '63c65b21-6bba-4eae-8456-9401d378675b';
    //   const headers: HttpHeaders = new HttpHeaders()
    //     .set('authtoken', `${token}`);
    //   return headers;
    //   // const token: string = this.wpnonce;
    //   // const headers: HttpHeaders = new HttpHeaders()
    //   //   .set('X-WP-Nonce', `${token}`);
    //   // return headers;
    // }
    checkOptions(options) {
        if (!options)
            return null;
        if (options.checkLoggedIn && options.checkLoggedIn === true && !this.authService.isLogged()) {
            return 'not logged in';
        }
        return null;
    }
    async getRequest(endpoint, pars, preventError, preventLoader, options) {
        const headers = await this.setHeaders();
        if (!pars) {
            pars = {};
        }
        pars.headers = headers;
        // console.log('getRequest', pars)
        if (!preventLoader)
            this.showLoader();
        if (options) {
            const optRet = this.checkOptions(options);
            if (optRet)
                return throwError(() => { return optRet; });
        }
        return this.http.get(`${this.getBaseUrl()}/${endpoint}`, pars).pipe(tap(() => {
            if (!preventLoader)
                this.hideLoader();
        }), catchError((err) => {
            if (!preventError)
                this.errorHandler.handleError(err);
            if (!preventLoader)
                this.hideLoader();
            return throwError(() => err);
        }));
        // const headers: any = this.setHeaders();
        // return this.http.get(this.buildUrl(this.URL(), endpoint), { headers: headers }).pipe(
        //   catchError((err: any) => {
        //     this.errorHandler.handleError(err);
        //     return err;
        //   })
        // );
    }
    getBaseUrl() {
        return this._URL;
    }
    buildUrl(url, endpoint) {
        if (url.endsWith("/") && endpoint.startsWith('/')) {
            endpoint = endpoint.substring(1);
        }
        else {
            if (!url.endsWith("/") && !endpoint.startsWith('/')) {
                endpoint = "/" + endpoint;
            }
        }
        url += endpoint;
        return url;
    }
    getSsoRequest(endpoint, ssoToken) {
        const headers = this.setSsoHeaders(ssoToken);
        return this.http.get(this.buildUrl(this.SSOURL, endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    postSsoRequest(data, endpoint, ssoToken) {
        const headers = this.setSsoHeaders(ssoToken);
        return this.http.post(this.buildUrl(this.SSOURL, endpoint), data, { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    configureOptions(options) {
        let ret = {};
        if (options.headers) {
            ret.headers = options.headers;
        }
        if (options.context) {
            ret.context = options.context;
        }
        if (options.observe) {
            ret.observe = options.observe;
        }
        if (options.params) {
            ret.params = options.params;
        }
        if (options.reportProgress) {
            ret.reportProgress = options.reportProgress;
        }
        if (options.responseType) {
            ret.responseType = options.responseType;
        }
        if (options.withCredentials) {
            ret.withCredentials = options.withCredentials;
        }
        return ret;
    }
    getRawRequest(endpoint, options, preventError, preventLoader) {
        let obs = null;
        if (options) {
            if (options instanceof HttpHeaders) {
                obs = this.http.get(`${endpoint}`, { headers: options });
            }
            else {
                obs = this.http.get(`${endpoint}`, this.configureOptions(options));
            }
        }
        else
            obs = this.http.get(`${endpoint}`);
        if (!preventLoader)
            this.showLoader();
        obs.pipe(tap(() => {
            if (!preventLoader)
                this.hideLoader();
        }), catchError((err) => {
            if (!preventLoader)
                this.hideLoader();
            if (!preventError)
                this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
        return obs;
    }
    getRequestTyped(endpoint, myType) {
        const headers = this.setHeaders();
        return this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    async getRequestPromise(endpoint) {
        const headers = await this.setHeaders();
        return this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    async getRawRequestPromise(endpoint) {
        const headers = await this.setHeaders();
        return this.http.get(endpoint, { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    getRequestObservable(endpoint) {
        return new Observable((observer) => {
            this.setHeaders().then((headers) => {
                this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
                    this.errorHandler.handleError(err);
                    observer.error(err);
                    return throwError(() => err);
                })).subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                });
            });
        });
    }
    getBlobRequest(endpoint) {
        const headers = this.setHeaders();
        if (!this.blobData[endpoint]) {
            this.blobData[endpoint] = this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers, responseType: 'blob' }).pipe(catchError((err) => {
                this.errorHandler.handleError(err);
                return throwError(() => err);
            }), map((val) => {
                if (val instanceof Blob)
                    this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
            }), publishReplay(1), refCount());
        }
        return this.blobData[endpoint];
    }
    getBlobRequestPromise(endpoint, baseurl) {
        const headers = this.setHeaders();
        const baseUrl = baseurl ? baseurl : this.getBaseUrl();
        if (!this.blobData[endpoint]) {
            this.blobData[endpoint] = this.http.get(this.buildUrl(baseUrl, endpoint), { headers: headers, responseType: 'blob' }).pipe(catchError((err) => {
                this.errorHandler.handleError(err);
                return throwError(() => err);
            }), map(val => {
                if (val instanceof Blob)
                    this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
            }), 
            // publishReplay(1),refCount()
            share({ connector: () => new ReplaySubject(1), resetOnError: false, resetOnComplete: false, resetOnRefCountZero: false })).toPromise();
        }
        return this.blobData[endpoint];
    }
    // async downloadFile(endpoint: string, fileName: string) {
    //   const blob: any = await this.getBlobRequestUnMappedPromise(endpoint);
    //   // await importedSaveAs(blob, fileName);
    //   importedSaveAs(blob, fileName);
    // }
    // async previewFile(endpoint: string, fileName?: string) {
    //   const blob = await this.getBlobRequestUnMappedPromise(endpoint);
    //   this.filesService.previewFile(blob);
    // }
    async getBlobRequestUnMapped(endpoint) {
        const headers = await this.setHeaders();
        return this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers, responseType: 'blob' }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    async getBlobRequestUnMappedPromise(endpoint, baseurl) {
        const headers = await this.setHeaders();
        const baseUrl = baseurl ? baseurl : this.getBaseUrl();
        return this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers, responseType: 'blob' }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    async getRequestUnMappedPromise(endpoint, baseurl) {
        const headers = await this.setHeaders();
        const baseUrl = baseurl ? baseurl : this.getBaseUrl();
        return this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    // getBlobRequestUnMappedPromise(endpoint: string): Promise<Blob> {
    //   const headers: any = this.setHeaders();
    //   return new Promise((resolve, reject) => {
    //     this.http.get(this.buildUrl(this.URL(), endpoint), { headers: headers, responseType: 'blob' }).subscribe(
    //       (response: Blob) => {
    //         resolve(response);
    //       },
    //       (error: any) => {
    //         this.errorHandler.handleError(error);
    //         reject(error);
    //       }
    //     );
    //   });
    // }
    async postRequest(endpoint, body, preventError, preventLoader) {
        const headers = await this.setHeaders();
        if (!preventLoader)
            this.showLoader();
        return this.http.post(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers }).pipe(tap(() => {
            if (!preventLoader)
                this.hideLoader();
        }), catchError((err) => {
            if (!preventError)
                this.errorHandler.handleError(err);
            if (!preventLoader)
                this.hideLoader();
            return throwError(() => err);
        }));
    }
    showLoader() {
        this.eventInteractionService.publishData({ event: 'showLoader', data: {} });
    }
    hideLoader() {
        this.eventInteractionService.publishData({ event: 'hideLoader', data: {} });
    }
    async postRequestPromise(endpoint, body, preventError, preventLoader) {
        const headers = await this.setHeaders();
        if (!preventLoader)
            this.showLoader();
        // console.log(headers);
        return this.http.post(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers }).pipe(tap(() => {
            if (!preventLoader)
                this.hideLoader();
        }), catchError((err) => {
            if (!preventError)
                this.errorHandler.handleError(err);
            if (!preventLoader)
                this.hideLoader();
            return throwError(() => err);
        })).toPromise();
    }
    postFileRequest(endpoint, body) {
        return new Promise((resolve, reject) => {
            this.setFileHeaders().then((headers) => {
                // console.log(body);
                let obs = this.http.post(this.buildUrl(this.getBaseUrl(), endpoint), body, {
                    headers: headers,
                    reportProgress: true,
                    observe: 'events'
                });
                obs.pipe(catchError((err) => {
                    this.errorHandler.handleError(err);
                    // reject(err);
                    return throwError(() => err);
                }));
                resolve(obs);
                return obs;
            }).catch((err) => {
                reject(err);
            });
        });
    }
    getFileRequest(endpoint) {
        return new Promise((resolve, reject) => {
            this.setFileHeaders().then((headers) => {
                // console.log(body);
                let obs = this.http.get(this.buildUrl(this.getBaseUrl(), endpoint), {
                    headers: headers,
                    reportProgress: true,
                    observe: 'events'
                });
                obs.pipe(catchError((err) => {
                    this.errorHandler.handleError(err);
                    // reject(err);
                    return throwError(() => err);
                }));
                resolve(obs);
                return obs;
            }).catch((err) => {
                reject(err);
            });
        });
    }
    postRawRequest(endpoint, body, headers, preventError) {
        let obs = null;
        if (headers)
            obs = this.http.post(`${endpoint}`, body, { headers: headers });
        else
            obs = this.http.post(`${endpoint}`, body);
        obs.pipe(catchError((err) => {
            if (!preventError)
                this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
        return obs;
    }
    async postFileRequestPromise(endpoint, body) {
        const headers = await this.setFileHeaders();
        return this.http.post(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    async putRequest(endpoint, body) {
        const headers = await this.setHeaders();
        return this.http.put(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    async putRequestPromise(endpoint, body) {
        const headers = await this.setHeaders();
        return this.http.put(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    async deleteRequest(endpoint) {
        const headers = await this.setHeaders();
        return this.http.delete(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        }));
    }
    async deleteRequestPromise(endpoint) {
        const headers = await this.setHeaders();
        return this.http.delete(this.buildUrl(this.getBaseUrl(), endpoint), { headers: headers }).pipe(catchError((err) => {
            this.errorHandler.handleError(err);
            return throwError(() => err);
        })).toPromise();
    }
    setSsoHeaders(token) {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token);
        return headers;
    }
    getRawRequestObservable(endpoint) {
        return new Observable((observer) => {
            this.setHeaders().then((headers) => {
                this.http.get(endpoint, { headers: headers }).pipe(takeUntil(this.destroy$), catchError((err) => {
                    this.errorHandler.handleError(err);
                    observer.error(err);
                    return throwError(() => err);
                })).subscribe((data) => {
                    if (data) {
                        observer.next(data);
                        observer.complete();
                    }
                });
            });
        });
    }
    destoryAllsubscriptions() {
        this.destroy$.next(true);
        this.destroy$.complete();
        // this.subscription.unsubscribe();
    }
}

class ApiWpService extends ApiService {
    setFileHeaders() {
        throw new Error('Method not implemented.');
    }
    constructor(http, errorHandler, sanitizer, authService, eventInteractionService
    // private next: HttpHandler,
    ) {
        super(http, sanitizer, authService, errorHandler, eventInteractionService);
        this.http = http;
        this.errorHandler = errorHandler;
        this.sanitizer = sanitizer;
        this.authService = authService;
        this.eventInteractionService = eventInteractionService;
        this._URL = '/wp-json';
        this.configured = true;
        // authService.setApiWpService(this);
    }
    setWpnonce(wpnonce) {
        this.wpnonce = wpnonce;
    }
    setHeaders() {
        return new Promise((resolve) => {
            const token = this.wpnonce ? this.wpnonce : '';
            let headers;
            if (this.basicAuth) {
                headers = new HttpHeaders()
                    .set('Content-Type', 'application/json')
                    .set('X-WP-Nonce', `${token}`)
                    .set('Authorization', `Basic ${this.basicAuth}`);
            }
            else {
                headers = new HttpHeaders()
                    .set('Content-Type', 'application/json')
                    .set('X-WP-Nonce', `${token}`);
            }
            resolve(headers);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiWpService, deps: [{ token: i1.HttpClient }, { token: i2.ErrorHandlerService }, { token: i3.DomSanitizer }, { token: MareAuthService }, { token: i2.EventInteractionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiWpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiWpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.ErrorHandlerService }, { type: i3.DomSanitizer }, { type: MareAuthService }, { type: i2.EventInteractionService }]; } });

class MareAuthService {
    constructor(config, tokenService, eventInteractionService, injector) {
        this.config = config;
        this.tokenService = tokenService;
        this.eventInteractionService = eventInteractionService;
        this.injector = injector;
        this.isWp = true;
        console.log('AuthService constructor', config, tokenService);
        if (config && config.isWp !== undefined && config.isWp !== null) {
            this.isWp = config.isWp;
        }
        else {
            this.isWp = false;
        }
        this.setupInfo();
        if (this.isWp) {
            this.apiWpService = this.injector.get(ApiWpService);
            if (config && config.wpConfig && config.wpConfig.serviceEndpoint) {
                this.apiWpService.configured = false;
                this.apiWpService.setEnvironment(config.wpConfig.serviceEndpoint, config.wpConfig.wpnonce, config.wpConfig.basicAuth);
            }
        }
    }
    setupInfo() {
        if (window.mare_ctx && window.mare_ctx.currentUser) {
            this.currentUser = window.mare_ctx.currentUser;
        }
        else if (window && window.ajax_msc_object && window.ajax_msc_object.currentUser) {
            this.currentUser = window.ajax_msc_object.currentUser;
        }
    }
    getCurrentUser() {
        return this.currentUser;
    }
    setApiWpService(apiWpService) {
        if (this.isWp) {
            this.tokenService.setApiWpService(apiWpService);
        }
    }
    getIsWp() {
        return this.isWp;
    }
    isLogged() {
        return this.tokenService.isLogged();
    }
    retrieveToken() {
        return new Promise((resolve, reject) => {
            if (this.isWp) {
                let t = this.tokenService.getValidToken();
                if (t)
                    resolve(t);
                else {
                    this.tokenService.triggerRefreshAndRetrieve().then((t) => {
                        if (t) {
                            resolve(t);
                            this.eventInteractionService.publishData({ event: 'newToken', data: { token: t } });
                        }
                        else {
                            let err = new Error('Token non valido o scaduto.');
                            reject(err);
                            this.eventInteractionService.publishData({ event: 'tokenExpired', data: {} });
                        }
                    }).catch((err) => {
                        reject(err);
                    });
                }
            }
            else {
                let t = this.tokenService.getAccessToken();
                resolve(t);
            }
        });
    }
    logout() {
        this.tokenService.logout();
    }
    start(params) {
        this.tokenService.start(params);
    }
    getAccessToken() {
        return this.tokenService.getAccessToken();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthService, deps: [{ token: 'MAREAUTHCONFIG', optional: true }, { token: TokenServiceAbstract }, { token: i2.EventInteractionService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['MAREAUTHCONFIG']
                }] }, { type: TokenServiceAbstract }, { type: i2.EventInteractionService }, { type: i0.Injector }]; } });

class MareAuthModule {
    static forRoot(config) {
        return {
            ngModule: MareAuthModule,
            providers: [
                MareAuthService,
                { provide: 'MAREAUTHCONFIG', useValue: config },
                config.tokenService || { provide: TokenServiceAbstract, useValue: config.tokenService }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MareAuthModule, imports: [CommonModule,
            NgxMareCommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthModule, providers: [
            MareAuthService
        ], imports: [CommonModule,
            NgxMareCommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MareAuthModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        NgxMareCommonModule
                    ],
                    providers: [
                        MareAuthService
                    ]
                }]
        }] });

class ApiOauthService extends ApiService {
    constructor(http, errorHandler, sanitizer, authService, eventInteractionService) {
        super(http, sanitizer, authService, errorHandler, eventInteractionService);
        this.http = http;
        this.errorHandler = errorHandler;
        this.sanitizer = sanitizer;
        this.authService = authService;
        this.eventInteractionService = eventInteractionService;
    }
    setHeaders() {
        return new Promise(async (resolve, reject) => {
            const token = await this.authService.retrieveToken().then((response) => {
                return response;
            }, (error) => {
                console.log(error);
                reject(error);
            });
            const headers = new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('Authorization', `Bearer ${token}`);
            resolve(headers);
        });
    }
    setFileHeaders() {
        return new Promise((resolve) => {
            const token = this.authService.getAccessToken();
            const headers = new HttpHeaders()
                .set('Authorization', `Bearer ${token}`);
            resolve(headers);
        });
    }
    buildUrl(url, endpoint) {
        if (url.endsWith("/") && endpoint.startsWith('/')) {
            endpoint = endpoint.substring(1);
        }
        else {
            if (!url.endsWith("/") && !endpoint.startsWith('/')) {
                endpoint = "/" + endpoint;
            }
        }
        url += endpoint;
        return url;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiOauthService, deps: [{ token: i1.HttpClient }, { token: i2.ErrorHandlerService }, { token: i3.DomSanitizer }, { token: MareAuthService }, { token: i2.EventInteractionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiOauthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiOauthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.ErrorHandlerService }, { type: i3.DomSanitizer }, { type: MareAuthService }, { type: i2.EventInteractionService }]; } });

class WpDefaultTokenService extends TokenServiceAbstract {
    constructor(apiWpService) {
        super();
        this.apiWpService = apiWpService;
        // private apiWpService!: ApiWpService;
        this.triggerRefreshAndRetrievePromise = null;
        // console.log('TokenService constructor', window.mare_ctx)
        if (window.mare_ctx && window.mare_ctx.tokenObj) {
            // console.log('setting token...');
            this.setTokenObj(window.mare_ctx.tokenObj);
        }
    }
    setApiWpService(apiWpService) {
        // console.log('setApiWpService', apiWpService)
        this.apiWpService = apiWpService;
    }
    start() {
        throw new Error('Method not implemented.');
    }
    logout() {
        throw new Error('Method not implemented.');
    }
    setTokenObj(tokenObj) {
        this.tokenObj = tokenObj;
        this.extractInformationFromToken();
        this.checkToSilentRefreshToken();
    }
    getTokenObj() {
        return this.tokenObj;
    }
    extractInformationFromToken() {
        this.token = this.tokenObj.access_token;
        const tokenPayload = this.token.split('.')[1];
        this.decodedPayload = JSON.parse(atob(tokenPayload));
        // this.decodedPayload = JSON.parse(Buffer.from(tokenPayload, 'base64').toString());
        this.refreshToken = this.tokenObj.refresh_token;
        this.decodedRefreshTokenPayload = JSON.parse(atob(this.refreshToken.split('.')[1]));
        // this.refreshTokenExp = new Date(this.decodedRefreshTokenPayload.exp*1000);
        // console.log('this.decodedPayload', this.decodedRefreshTokenPayload,this.refreshTokenExp);
        return this.decodedPayload;
    }
    getValidToken() {
        if (this.ifTokenExpired()) {
            return null;
        }
        else {
            return this.token;
        }
    }
    getToken() {
        return this.token;
    }
    ifTokenExpired() {
        if (!this.decodedPayload || !this.decodedPayload.exp || !this.token)
            return true;
        const now = new Date();
        const exp = new Date(this.decodedPayload.exp * 1000);
        return now > exp;
    }
    ifRefreshTokenExpired() {
        if (!this.decodedRefreshTokenPayload || !this.decodedRefreshTokenPayload.exp || !this.refreshToken)
            return true;
        const now = new Date();
        const exp = new Date(this.decodedRefreshTokenPayload.exp * 1000);
        return now > exp;
    }
    getAccessToken() {
        const vt = this.getValidToken();
        if (vt) {
            return vt;
        }
        return '';
    }
    isLogged() {
        return this.getValidToken() !== null;
    }
    /**recuperiamo dappima il token_refresh e poi il token valido */
    triggerRefreshAndRetrieve() {
        if (this.triggerRefreshAndRetrievePromise)
            return this.triggerRefreshAndRetrievePromise;
        this.triggerRefreshAndRetrievePromise = new Promise((resolve, reject) => {
            this.triggerTokenRefresh().then((response) => {
                console.log(response);
                this.retrieveRemoteToken().then((t) => {
                    resolve(t);
                }).catch((err) => {
                    reject(err);
                }).finally(() => {
                    this.cleanTokenRefreshPromise();
                });
            }).catch((err) => {
                this.cleanTokenRefreshPromise();
                reject(err);
            });
        });
        return this.triggerRefreshAndRetrievePromise;
    }
    cleanTokenRefreshPromise() {
        setTimeout(() => {
            this.triggerRefreshAndRetrievePromise = null;
        }, 10);
    }
    triggerTokenRefresh() {
        return new Promise((resolve, reject) => {
            this.apiWpService.getRequestObservable('msc/v1/oauth2TriggerRefresh').pipe(catchError$1((err) => {
                reject(err);
                return err;
            })).subscribe((response) => {
                if (response.status === 'ok') {
                    resolve(true);
                }
                else {
                    reject(false);
                }
            });
        });
    }
    retrieveRemoteToken() {
        return new Promise((resolve, reject) => {
            this.apiWpService.getRequestObservable('msc/v1/oauth2RetrieveToken').pipe(catchError$1((err) => {
                reject(err);
                return err;
            }))
                .subscribe((response) => {
                if (response.status === 'ok' && response.payload) {
                    /**salviamo il token e restituiamo il token valido*/
                    this.setTokenObj(response.payload);
                    let validToken = this.getValidToken();
                    resolve(validToken);
                }
                else {
                    reject(response);
                }
            });
        });
    }
    checkToSilentRefreshToken() {
        if (this.isSilentRefreshTokenEnabled()) {
            this.startSilentRefreshToken();
        }
    }
    isSilentRefreshTokenEnabled() {
        return true;
    }
    getTokenExpirationDate() {
        if (!this.decodedPayload || !this.decodedPayload.exp)
            return null;
        return this.decodedPayload.exp;
    }
    getRefreshTokenExpirationDate() {
        if (!this.decodedRefreshTokenPayload || !this.decodedRefreshTokenPayload.exp)
            return null;
        return this.decodedRefreshTokenPayload.exp;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WpDefaultTokenService, deps: [{ token: ApiWpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WpDefaultTokenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WpDefaultTokenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ApiWpService }]; } });

/*
 * Public API Surface of mare-auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiOauthService, ApiService, ApiServiceOptions, ApiWpService, MareAuthModule, MareAuthService, TokenServiceAbstract, WpDefaultTokenService };
